var general_rtlignore_default = {
  "alignLeft": "aAAHs",
  "textWrapNowrap": "AUApt",
  "alignRight": "mC8bp",
  "alignCenter": "_53iv9",
  "sizeFullWidth": "oFnW2",
  "renderedInTable": "_2x76i",
  "sizeOriginal": "_4RlDx",
  "sizeContent": "ybWK6",
  "sizeSmall": "gnMI3",
  "sizeSmallCenter": "AhrWJ",
  "flex": "EwQa1"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore-scss.js.map
